<template>
  <v-app>
    <component :is="currentLayout" v-if="isRouterLoaded">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </component>

    <v-snackbar
      v-model="errorBar"
      color="error"
      class="headline font-weight-bold"
      :timeout="-1"
      elevation="24"
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" color="white" @click="clearError()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="toastBar" color="success" class="title">
      {{ toastMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" color="white" @click="clearToast()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style lang="scss">
@media print {
  .print-only {
    display: block;
  }
  .no-print {
    visibility: hidden;
    display: none;
  }
  .v-main {
    padding: 0 !important;
  }
}
</style>

<script>
import Auth from "./common/firebase.auth";
// import AppMenu from "./components/AppMenu";
import { mapGetters } from "vuex";

// Layouts
import defaultLayout from "./layouts/DefaultLayout";
import simpleLayout from "./layouts/SimpleLayout";
import authLayout from "./layouts/AuthLayout";
import printLayout from "./layouts/PrintLayout";
import errorLayout from "./layouts/ErrorLayout";

// Dayjs
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
dayjs.extend(buddhistEra);
dayjs.locale("th");

export default {
  name: "App",
  computed: {
    ...mapGetters([
      "currentSchool",
      "errorMessage",
      "toastMessage",
      "currentUser",
      "showMenu"
    ]),
    today() {
      return dayjs();
    },
    isRouterLoaded: function() {
      if (this.$route.name !== null) return true;

      return false;
    },
    currentLayout: function() {
      const layout = this.$route.meta.layout || "default";

      return layout + "Layout";
    }
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.errorBar = true;
      } else {
        this.errorBar = false;
      }
    },
    errorBar(val) {
      if (val === false) {
        this.clearError();
      }
    },
    toastMessage(val) {
      if (val) {
        this.toastBar = true;
      } else {
        this.toastBar = false;
      }
    },
    toastBar(val) {
      if (val === false) {
        this.clearToast();
      }
    }
  },
  filters: {
    menuDate: date => {
      if (!date) {
        return null;
      }
      return dayjs(date).format("DD MMMM BBBB");
    }
  },
  components: {
    // AppMenu,
    defaultLayout,
    simpleLayout,
    authLayout,
    errorLayout,
    printLayout
  },
  data: () => ({
    mini: false,
    timeout: 3000,
    errorBar: false,
    toastBar: false,
    drawer: null,
    menu: false,
    fav: false,
    hints: false,
    message: false
  }),
  mounted() {
    this.checkAuth();

    if (this.$vuetify.breakpoint.name == "xs") {
      this.drawer = false;
    } else {
      this.drawer = true;
    }
  },
  methods: {
    menuButtonTapped() {
      //this.drawer = !this.drawer;
      this.$store.dispatch("toggleMenu", !this.showMenu);
    },
    checkAuth() {
      this.$store.dispatch("checkAuth");
    },
    async logout() {
      await Auth.signOut();
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    clearError() {
      this.$store.dispatch("clearError");
    },
    clearToast() {
      this.$store.dispatch("clearToast");
    }
  }
};
</script>

<style scoped>
/**
 * Transition animation between pages
 */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
